module.exports = __webpack_public_path__ + "img/tarde_c3@2x.75bf4978.png";